import script from "./EditDurationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDurationModal.vue?vue&type=script&setup=true&lang=js"

import "./EditDurationModal.vue?vue&type=style&index=0&id=1d1f7266&lang=css"

const __exports__ = script;

export default __exports__